import { useEffect, useState } from "react";
import prettier from "prettier/standalone";
import parserHtml from "prettier/plugins/html";

export const useFormattedHtml = (rawHtml: string, active: boolean) => {
  const [formatted, setFormatted] = useState(rawHtml);

  useEffect(() => {
    const format = async () => {
      if (active) {
        try {
          const pretty = await prettier.format(rawHtml, {
            parser: "html",
            plugins: [parserHtml],
          });
          setFormatted(pretty);
        } catch {
          setFormatted(rawHtml);
        }
      }
    };

    format();
  }, [rawHtml, active]);

  return formatted;
};
